export default __webpack_public_path__ + "static/media/CI2.1cd79af4.png";